import React from 'react'
import Navbar from '../Navbar';
import Footer from '../Footer';
import investerBanner from '../../assests/investor relationship/handshake.webp';
import '../../hamcss/investor.css';
import { useState } from 'react'
import { FaRegFilePdf } from "react-icons/fa";
import { Link } from 'react-router-dom';

import Fy25a from '../../assests/sgPdf/Statement of deviation(s) or variation(s)/FY24-25/Statement of Deviation 28.05.2024.7e973c5fa49de3962d0e.pdf';
import Fy25b from '../../assests/sgPdf/Statement of deviation(s) or variation(s)/FY24-25/Q3FY25_Monitoring Agency.pdf';
import Fy25c from '../../assests/sgPdf/Statement of deviation(s) or variation(s)/FY24-25/Q3FY25_Statement of deviation.pdf';
import Fy26a from '../../assests/sgPdf/Statement of deviation(s) or variation(s)/FY25-26/SG Finserve - MA Report Q4FY25.pdf';
import Fy26b from '../../assests/sgPdf/Statement of deviation(s) or variation(s)/FY25-26/Monitoring Agency Report_June2025.pdf';
import Fy26c from '../../assests/sgPdf/Statement of deviation(s) or variation(s)/FY25-26/Monitoring Agency report_30-09-2025.pdf';
import Fy23a from '../../assests/sgPdf/Statement of deviation(s) or variation(s)/FY23-24/Statement+of+Deviation+25.01.2023.pdf';
import Fy24a from '../../assests/sgPdf/Statement of deviation(s) or variation(s)/FY23-24/Dec-SDD.pdf';
import Fy24b from '../../assests/sgPdf/Statement of deviation(s) or variation(s)/FY23-24/June-SDD.pdf';
import Fy24c from '../../assests/sgPdf/Statement of deviation(s) or variation(s)/FY23-24/sept SDD.pdf';
import fy23 from '../../assests/sgPdf/Statement of deviation(s) or variation(s)/FY22-23/Statement+of+Deviation+08.11.2022.pdf';




const Statement_of_deviation = () => {

    const [selectedOption, setSelectedOption] = useState("option0"); // State to track selected option

    const handleOptionChange = (event) => {
        setSelectedOption(event.target.value); // Update selected option when changed
    };


    return (
        <>

            <Navbar />
            <section>
                <div className="BreadArea" style={{
                    //  for /beta server 
                    backgroundImage: `url(${investerBanner})`,
                    // backgroundImage: "url('images/Bread.png')",
                }}>
                    <div className="container">
                        <h2>Statement of deviation(s) or variation(s)</h2>
                    </div>
                </div>
            </section>


            <section className="main-an">

                <div className="main-an-box">
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <h2 className='h2-text'>Statement of deviation(s) or variation(s)</h2>
                        <div>
                            <select className="select-class" onChange={handleOptionChange}>
                                <option value="option0">FY 2025-2026</option>
                                <option value="option">FY 2024-2025</option>
                                <option value="option1">FY 2023-2024</option>
                                <option value="option2">FY 2022-2023</option>


                            </select>
                        </div>
                    </div>

                    <div style={{ marginTop: '50px' }}>
                        {/* Conditionally render PDFs based on selected option */}
                        {selectedOption === "option0" && (
                            <>
                               <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={Fy26a} target='blank'>  <h6>SG Finserve - MA Report Q4FY25</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={Fy26b} target='blank'>  <h6>Monitoring Agency Report_June2025</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={Fy26c} target='blank'>  <h6>Monitoring Agency report_30-09-2025</h6> </a>
                                </div>
                            </>

                        )}
                                
                        {selectedOption === "option" && (
                            <>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={Fy25a} target='blank'>  <h6>Statement of Deviation 28.05.2024</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={Fy25b} target='blank'>  <h6>Q3FY25_Monitoring Agency</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={Fy25c} target='blank'>  <h6>Q3FY25_Statement of deviation</h6> </a>
                                </div>
                                




                            </>

                        )}
                        {selectedOption === "option1" && (
                            <>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={Fy24b} target='blank'>  <h6>Statement+of+Deviation+June</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={Fy24c} target='blank'>  <h6>Statement+of+Deviation+Sept</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={Fy24a} target='blank'>  <h6>Statement+of+Deviation+Dec</h6> </a>
                                </div>





                            </>

                        )}




                        {selectedOption === "option2" && (
                            <>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={Fy23a} target='blank'>  <h6>Statement+of+Deviation+25.01.2023.pdf</h6> </a>
                                </div>
                                <div className="pdf-clas-2">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy23} target='blank'> <h6>Statement+of+Deviation+08.11.2022.pdf</h6> </a>
                                </div>





                            </>
                        )}
                        {selectedOption === "option3" && (
                            <>

                            </>
                        )}
                        {selectedOption === "option4" && (
                            <>

                            </>
                        )}
                        {selectedOption === "option5" && (
                            <>

                            </>
                        )}
                        {selectedOption === "option6" && (
                            <>

                            </>
                        )}
                    </div>
                </div>

            </section>



            <Footer />


        </>
    )
}


export default Statement_of_deviation